import CarrouselStyle from "./style.module.scss";

export type CarouselItemProps = {
  titulo: string;
  description: string;
  image?: string;
  column?: boolean;
  tab?: number;
  index?: number;
};

const CarouselItem: React.FC<CarouselItemProps> = ({
  titulo,
  description,
  image,
  column,
  tab,
  index
}) => {
  return (
    <div
      role='carousel-item'
      hidden={tab == index ? false : true}
      className={`${CarrouselStyle.item} ${
        tab == index ? CarrouselStyle.verSiguiente : null
      } row mx-0 `}>
      <div
        className={`${column ? "col-5" : "col-12"} 
        d-flex justify-content-center align-items-center`}>
        <div className='col-12 text-center mx-auto'>
          <p title='titulo' className='h2 w-75 mx-auto'>
            {titulo}
          </p>
          <div title='descripcion' className=''>
            {description}
          </div>
        </div>
      </div>

      <div
        className={`${column ? "col" : "col-11 mx-auto"} ${CarrouselStyle.img} 
        px-0 d-flex justify-content-center align-items-center`}>
        <img alt='imagen carousel' className='img-fluid' src={image} />
      </div>
    </div>
  );
};

export default CarouselItem;
